import {SortDirection} from '@mui/material'
import {UseQueryResult, useQuery, keepPreviousData} from '@tanstack/react-query'
import {omit} from 'lodash'

import {QueryKeyName, getFilteredActions} from '../../common/backend'
import {CLIENT_SIDE_FILTER_KEYS} from '../../consts'
import {ActionItem, PaginatedList, ActionItemKey, FilteredActionsParams} from '../../types'
import {useActionFilters} from '../urlParameters/useActionFilters'
import {usePlantUpmId} from '../usePlantUpmIdContext'

type Params = {
  page: number
  rowsPerPage: number
  sortByKey?: ActionItemKey
  order: SortDirection
}

export const useFilteredActions = (params: Params): UseQueryResult<PaginatedList<ActionItem>> => {
  const plantId = usePlantUpmId()
  const filters = omit(useActionFilters(), CLIENT_SIDE_FILTER_KEYS)
  const parameters: FilteredActionsParams = {
    ...params,
    ...filters,
    plantId
  }

  return useQuery<PaginatedList<ActionItem>>({
    queryKey: [QueryKeyName.GetActionItems, parameters],
    queryFn: () => getFilteredActions(parameters),
    placeholderData: keepPreviousData
  })
}
